/* eslint-disable react/no-danger */
import React, { Component } from 'react';
import { Button, RadioButton, RadioButtonGroup } from 'carbon-components-react';
import { Editor } from 'react-draft-wysiwyg';
import { ContentState, EditorState, convertToRaw } from 'draft-js';
import draftToHtml from 'draftjs-to-html';
import htmlToDraft from 'html-to-draftjs';
import { getDmService } from '../../../services/Api';
import { StepCard } from '../../index';
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";

// Definimos um separador para unir/dividir o conteúdo dos dois editores
const SECONDARY_EDITOR_SEPARATOR = '<!-- SECONDARY_EDITOR_SEPARATOR -->';

class BriefingRequestProduct extends Component {
  constructor(props) {
    super(props);
    this.state = {
      advanced: false,
      idxBriefing: 0,
      listBriefings: [],
      idUrl: null,
      editorState: EditorState.createEmpty(), // Estado para o editor primário
      secondaryEditorState: EditorState.createEmpty(), // Estado para o editor secundário
      createText: '0', // '1' para Sim, '0' para Não. Inicializa como 'Não'.
      primaryEditorContentHTML: '', // Armazena o HTML do editor primário
      secondaryEditorContentHTML: '', // Armazena o HTML do editor secundário
    };
  }

  componentWillMount = () => {
    const { dataRequest } = this.props;
    const existDataRequest = Object.prototype.hasOwnProperty.call(dataRequest, 'idGrupo');
    if (existDataRequest) {
      this.loadProductRequest();
      this.implementValuesRequest();
    }
  };

  componentWillUpdate = async () => {
    const { match } = this.props;
    const { idUrl } = this.state;
    if (idUrl !== match.params.id) {
      await this.setState({
        idUrl: match.params.id
      });
    }
  };

  componentDidMount() {
    // O createText já é inicializado no construtor como '0'.
  };

  // Ajuste na lógica para evitar sobrescrever o estado createText do usuário
  componentWillReceiveProps(newProps) {
    const { listBriefings: currentListBriefings } = this.state;
    const { dataProduct, dataRequest } = newProps;
    const prevDataRequest = this.props.dataRequest; // Obtém as props anteriores para comparação

    const existDataRequest = Object.prototype.hasOwnProperty.call(dataRequest, 'idGrupo');
    const prevExistDataRequest = Object.prototype.hasOwnProperty.call(prevDataRequest, 'idGrupo');

    const { listSizes } = dataProduct;
    const newList = [];

    let newState = {}; // Objeto para acumular as atualizações de estado

    if (!existDataRequest) {
      // Se não há dataRequest, reseta para o padrão
      if (prevExistDataRequest) { // Apenas reseta se havia um dataRequest anteriormente
        newState = {
          listBriefings: [],
          createText: '0',
          primaryEditorContentHTML: '',
          secondaryEditorContentHTML: '',
          editorState: EditorState.createEmpty(),
          secondaryEditorState: EditorState.createEmpty(),
        };
      } else if (listSizes && listSizes.length > 0 && currentListBriefings.length === 0) {
        // Carregamento inicial sem dataRequest, popula listBriefings
        listSizes.forEach(item => {
          newList.push({
            id: item.indice,
            value: item.value,
            otherValues: item,
            texto: item.texto || ''
          });
        });
        newState = {
          listBriefings: newList,
          createText: '0', // Padrão para nova requisição vazia
          primaryEditorContentHTML: '',
          secondaryEditorContentHTML: '',
          editorState: EditorState.createEmpty(),
          secondaryEditorState: EditorState.createEmpty(),
        };
      }
    } else {
      // dataRequest existe
      const list = dataRequest.detalhes.map(item => ({
        id: item.id,
        texto: item.briefing
      }));

      listSizes.forEach((item, idx) => {
        if (currentListBriefings.length > idx) newList.push(currentListBriefings[idx]);
        else if (list.length > idx) newList.push(list[idx]);
        else {
          newList.push({ id: 0, texto: '' });
        }
      });
      newState.listBriefings = newList;

      // Apenas atualiza createText e os estados dos editores se dataRequest.criarTexto mudou
      // ou se é a primeira vez que dataRequest é carregado.
      const incomingCreateText = dataRequest.criarTexto === 1 ? '1' : '0';
      const prevIncomingCreateText = prevDataRequest && prevDataRequest.criarTexto === 1 ? '1' : '0';

      // Verifica se dataRequest.criarTexto mudou ou se é um novo carregamento de dataRequest
      if (incomingCreateText !== prevIncomingCreateText || !prevExistDataRequest) {
        let editorState = EditorState.createEmpty();
        let secondaryEditorState = EditorState.createEmpty();
        let primaryHtml = '';
        let secondaryHtml = '';

        if (newList[0] && newList[0].texto) {
          const fullText = newList[0].texto;
          const parts = fullText.split(SECONDARY_EDITOR_SEPARATOR);

          primaryHtml = parts[0] || '';
          const blocksFromHtmlPrimary = htmlToDraft(primaryHtml);
          if (blocksFromHtmlPrimary.contentBlocks) {
            const contentStatePrimary = ContentState.createFromBlockArray(blocksFromHtmlPrimary.contentBlocks, blocksFromHtmlPrimary.entityMap);
            editorState = EditorState.createWithContent(contentStatePrimary);
          }

          if (incomingCreateText === '1' && parts.length > 1) {
            secondaryHtml = parts[1] || '';
            const blocksFromHtmlSecondary = htmlToDraft(secondaryHtml);
            if (blocksFromHtmlSecondary.contentBlocks) {
              const contentStateSecondary = ContentState.createFromBlockArray(blocksFromHtmlSecondary.contentBlocks, blocksFromHtmlSecondary.entityMap);
              secondaryEditorState = EditorState.createWithContent(contentStateSecondary);
            }
          }
        }

        newState = {
          ...newState,
          editorState,
          secondaryEditorState,
          primaryEditorContentHTML: primaryHtml,
          secondaryEditorContentHTML: secondaryHtml,
          createText: incomingCreateText,
        };
      }
    }

    // Apenas chama setState se houver mudanças reais para aplicar
    if (Object.keys(newState).length > 0) {
      this.setState(newState);
    }
  }

  loadProductRequest = async () => {
    const { dataRequest } = this.props;
    const { idProduto } = dataRequest;
    try {
      const data = await getDmService(`/Pedido/GetNomeProduto/?grupo=${dataRequest.idGrupo}`);
      const idsSearch = data.find(item => parseInt(item.id, 10) === parseInt(idProduto, 10));
      const productRequest = { id: idsSearch.id, label: idsSearch.nome };
      this.setState({
        productRequest
      });
    } catch (error) {
      console.log(error);
    }
  };

  implementValuesRequest = () => {
    const { dataRequest } = this.props;
    const existDataRequest = Object.prototype.hasOwnProperty.call(dataRequest, 'idGrupo');
    if (existDataRequest) {
      const list = dataRequest.detalhes.map(item => ({
        id: item.id,
        texto: item.briefing
      }));
      let editorState = EditorState.createEmpty();
      let secondaryEditorState = EditorState.createEmpty();
      let primaryHtml = '';
      let secondaryHtml = '';

      const initialCreateText = dataRequest.criarTexto === 1 ? '1' : '0';

      if (list[0] && list[0].texto) {
        const fullText = list[0].texto;
        const parts = fullText.split(SECONDARY_EDITOR_SEPARATOR);

        primaryHtml = parts[0] || '';
        const blocksFromHtmlPrimary = htmlToDraft(primaryHtml);
        if (blocksFromHtmlPrimary.contentBlocks) {
          const contentStatePrimary = ContentState.createFromBlockArray(blocksFromHtmlPrimary.contentBlocks, blocksFromHtmlPrimary.entityMap);
          editorState = EditorState.createWithContent(contentStatePrimary);
        }

        if (initialCreateText === '1' && parts.length > 1) {
          secondaryHtml = parts[1] || '';
          const blocksFromHtmlSecondary = htmlToDraft(secondaryHtml);
          if (blocksFromHtmlSecondary.contentBlocks) {
            const contentStateSecondary = ContentState.createFromBlockArray(blocksFromHtmlSecondary.contentBlocks, blocksFromHtmlSecondary.entityMap);
            secondaryEditorState = EditorState.createWithContent(contentStateSecondary);
          }
        }
      }

      this.setState({
        listBriefings: list,
        editorState,
        secondaryEditorState,
        primaryEditorContentHTML: primaryHtml,
        secondaryEditorContentHTML: secondaryHtml,
        createText: initialCreateText,
      });
    }
  };

  renderCreateText = () => {
    const { createText } = this.state;
    const { onCreateTextChange } = this.props;
    return (
      <React.Fragment>
        <div className='radio-input'>
          <p className='color-red'><b>Este pedido envolve a criação ou revisão de texto?</b></p>
          <div className="inline-radio">
            <RadioButtonGroup
              legendText="Radio button heading"
              name="CriarTexto"
              valueSelected={createText !== undefined && createText !== null ? String(createText) : undefined}
              onChange={value => {
                console.log('Radio button changed to:', value); // DEBUG: Verifique o valor aqui
                this.setState({ createText: value }); // Salva como string '1' ou '0'
                if (onCreateTextChange) {
                  onCreateTextChange(value); // Passa string para o pai
                }
                // Limpa o editor secundário se o usuário mudar para 'Não'
                if (value === '0') {
                  this.setState({
                    secondaryEditorState: EditorState.createEmpty(),
                    secondaryEditorContentHTML: ''
                  });
                }
              }}
            >
              <RadioButton
                value="1"
                labelText="Sim"
                id="radio-1"
              />
              <RadioButton
                value="0"
                labelText="Não"
                id="radio-2"
              />
            </RadioButtonGroup>
          </div>
        </div>
      </React.Fragment>
    );
  };

  renderDescription = () => {
    const { dataProduct, dataRequest, isKit } = this.props;
    const { productSave } = dataProduct;
    const { listBriefings, productRequest, createText } = this.state;
    const nameProduct =
      productSave && productSave.label
        ? productSave.label
        : productRequest
          ? productRequest.label
          : '';

    // A descrição deve mostrar o texto combinado se createText for '1'
    const displayBriefings = listBriefings.map(item => {
      if (createText === '1' && item.texto.includes(SECONDARY_EDITOR_SEPARATOR)) {
        const [primary, secondary] = item.texto.split(SECONDARY_EDITOR_SEPARATOR);
        return {
          ...item,
          texto: `<div>${primary}</div><div><strong>Informações Adicionais:</strong></div><div>${secondary}</div>`
        };
      }
      return item;
    });

    return (
      <React.Fragment>
        {dataRequest.criarTexto === 1 && (
          <p className="description">
            <strong>Este pedido envolve a criação ou revisão de texto</strong>
          </p>
        )}
        {displayBriefings.length > 0 && !isKit &&
          displayBriefings.map((item, index) => (
            <p key={index} className="description">
              <strong>{`${nameProduct}  ${item.texto ? ' - ' : ''}`}</strong>
              <div dangerouslySetInnerHTML={{ __html: displayBriefings[index].texto }} />
            </p>
          ))}
        {displayBriefings.length > 0 && isKit && (
          <p key={0} className="description">
            <strong>{`${nameProduct} ${displayBriefings[0].texto ? ' - ' : ''}`}</strong>
            <div dangerouslySetInnerHTML={{ __html: displayBriefings[0].texto }} />
          </p>
        )}
      </React.Fragment>
    );
  };

  advance = async () => {
    const { saveStep } = this.props;
    const { listBriefings, createText, primaryEditorContentHTML, secondaryEditorContentHTML } = this.state;
    const { isKit, dataProduct } = this.props;
    const { productSave } = dataProduct;

    const updatedListBriefings = [...listBriefings];

    // Determina se o produto é do tipo "Texto"
    const productInvolvesText = productSave && productSave.tipoUso && productSave.tipoUso.includes("Texto");

    let combinedContent = primaryEditorContentHTML;

    // Apenas combina o conteúdo se o produto NÃO for do tipo "Texto" E o radio button "Sim" estiver ativo
    if (!productInvolvesText && createText === '1') {
      combinedContent += SECONDARY_EDITOR_SEPARATOR + secondaryEditorContentHTML;
    }

    if (isKit) {
      updatedListBriefings.forEach(item => {
        item.texto = combinedContent;
      });
    } else if (updatedListBriefings.length > 0) {
      updatedListBriefings[0].texto = combinedContent;
    }

    const dataToSave = {
      listSizes: updatedListBriefings,
      // O valor de criarTexto só é relevante se o produto NÃO for do tipo "Texto"
      criarTexto: !productInvolvesText ? (createText === '1' ? 1 : 0) : 0,
    };

    await saveStep(
      dataToSave,
      'briefing'
    );
    await this.stepCardRef.toggleContent();
  };

  cancel = () => {
    this.stepCardRef.toggleContent();
  };

  briefingOk = () => {
    const { dataProduct } = this.props;
    const { createText, primaryEditorContentHTML, secondaryEditorContentHTML } = this.state;
    const { dataFilters, productSave } = dataProduct || {};

    // Determina se o produto é do tipo "Texto"
    const productInvolvesText = productSave && productSave.tipoUso && productSave.tipoUso.includes("Texto");

    // Se o briefing for opcional, sempre retorna true
    if (dataFilters && !dataFilters.briefing) {
      return true;
    }

    // Verifica se o editor primário tem conteúdo (ignorando <p></p> vazio)
    const primaryHasContent = primaryEditorContentHTML && primaryEditorContentHTML.trim() !== '<p></p>';

    // Se o produto for do tipo "Texto", apenas o editor primário é relevante para validação
    if (productInvolvesText) {
      return primaryHasContent;
    }

    // Se o produto NÃO for do tipo "Texto", a lógica do radio button se aplica
    if (createText === '1') {
      // Se "Sim" for selecionado, o editor secundário também é relevante.
      // Consideramos OK se o primário OU o secundário tiverem conteúdo.
      const secondaryHasContent = secondaryEditorContentHTML && secondaryEditorContentHTML.trim() !== '<p></p>';
      return primaryHasContent || secondaryHasContent;
    } else {
      // Se "Não" for selecionado, apenas o editor primário é relevante.
      return primaryHasContent;
    }
  }

  addTag = async (tag, idx) => {
    const { primaryEditorContentHTML } = this.state;

    let txtTag = '';
    if (tag === '<CHAMADA>') {
      txtTag = ' <p>Chamada</p> ';
    } else if (tag === '<PRAZO>') {
      txtTag = ' <p>Tenha + prazo pra pagar</p> ';
    } else if (tag === '<DESCONTOS_OFERTAS>') {
      txtTag = ' <p>Descontos e ofertas exclusivas</p> ';
    } else if (tag === '<BAIXE_APP>') {
      txtTag = ' <p>whatsapp + qrcode</p> ';
    } else if (tag === '<AUMENTO_LIMITE>') {
      txtTag = ' <p>Aumento de limite</p> ';
    } else if (tag === '<RAPIDA_APROVACAO>') {
      txtTag = ' <p>Rápida aprovação</p> ';
    } else if (tag === '<CARTAO_ADICIONAL>') {
      txtTag = ' <p>Cartão adicional</p> ';
    } else {
      txtTag = ' <p>Parcelamento em X</p> ';
    }

    // Adiciona a tag ao conteúdo HTML atual do editor primário
    const newHtmlContent = primaryEditorContentHTML + txtTag;

    // Converte o novo HTML para EditorState
    const blocksFromHtml = htmlToDraft(newHtmlContent);
    const { contentBlocks, entityMap } = blocksFromHtml;
    const contentState = ContentState.createFromBlockArray(contentBlocks, entityMap);
    const newEditorState = EditorState.createWithContent(contentState);

    await this.setState({
      editorState: newEditorState,
      primaryEditorContentHTML: newHtmlContent,
    });
  };

  renderOptional = () => {
    const { dataProduct } = this.props;
    const { dataFilters } = dataProduct;
    if (dataFilters && !dataFilters.briefing) {
      return <span className="optional"> (opcional)</span>;
    }
    return '';
  };

  entityMapper = (entity) => {
    if (!entity) {
      return "";
    }
    if (entity.type === "DIV") {
      return `<div>${entity.data.innerHTML}</div>`;
    }
    if (entity.type === "TABLE") {
      return `<table>${entity.data.innerHTML}</table>`;
    }
    if (entity.type === "TBODY") {
      return `<tbody>${entity.data.innerHTML}</tbody>`;
    }
    if (entity.type === "TR") {
      return `<tr>${entity.data.innerHTML}</tr>`;
    }
    if (entity.type === "TH") {
      return `<th>${entity.data.innerHTML}</th>`;
    }
    if (entity.type === "TD") {
      return `<td>${entity.data.innerHTML}</td>`;
    }
    if (entity.type === "P") {
      return `<p>${entity.data.innerHTML}</p>`;
    }
    if (entity.type === "STYLE") {
      return `<style>${entity.data.innerHTML}</style>`;
    }
    return "";
  }

  onPrimaryEditorStateChange = (editorState) => {
    const primaryEditorHTML = draftToHtml(
      convertToRaw(editorState.getCurrentContent()),
      null,
      false,
      this.entityMapper
    );
    this.setState({
      editorState,
      primaryEditorContentHTML: primaryEditorHTML,
    });
  };

  onSecondaryEditorStateChange = (secondaryEditorState) => {
    const secondaryEditorHTML = draftToHtml(
      convertToRaw(secondaryEditorState.getCurrentContent()),
      null,
      false,
      this.entityMapper
    );
    this.setState({
      secondaryEditorState,
      secondaryEditorContentHTML: secondaryEditorHTML,
    });
  };

  render() {
    const { advanced, listBriefings, productRequest, editorState, secondaryEditorState, createText } = this.state;
    const { disabledCard, isFinished, dataProduct, isKit } = this.props;
    const { productSave } = dataProduct;

    const nameProduct =
      productSave && productSave.label
        ? productSave.label
        : productRequest
          ? productRequest.label
          : '';

    // Determina se o produto envolve texto para o label do editor principal E para a visibilidade do radio button/segundo editor
    const productInvolvesText = productSave && productSave.tipoUso && productSave.tipoUso.includes("Texto");

    return (
      <StepCard
        onRef={ref => {
          this.stepCardRef = ref;
        }}
        title="Briefing"
        optional={this.renderOptional()}
        description={this.renderDescription()}
        isFinished={isFinished}
        onToogle={advanced}
      >
        <div>
          <div>
            {/* O radio button só será renderizado se o produto NÃO for do tipo "Texto" */}
            {!productInvolvesText && this.renderCreateText()}
          </div>
          {/* Editor Secundário (Texto): Mostra ANTES do Arte se o produto NÃO for do tipo "Texto" E "Sim" for selecionado */}
          {!productInvolvesText && createText === '1' && (
            <div className="bx--row v-md-margin">
              <div className="bx--col-xs-12 bx--col-md-12">
                <label className="bx--label">Briefing de Texto</label>
                <p className="description">
                  Forneça detalhes adicionais, referências, ou qualquer outra informação que ajude na criação ou revisão do texto.
                </p>
                <Editor
                  editorState={secondaryEditorState} // Vincula ao estado do editor secundário
                  editorClassName="border-editor"
                  onEditorStateChange={this.onSecondaryEditorStateChange}
                />
              </div>
            </div>
          )}

          {isKit ? (
            <div key={0}>
              <div className="bx--row">
                <div className="bx--col-xs-12 bx--col-md-12">
                  <label className="bx--label">{`${nameProduct}`}</label>
                  <Editor
                    editorState={editorState} // Editor Primário
                    editorClassName="border-editor"
                    onEditorStateChange={this.onPrimaryEditorStateChange}
                  />
                </div>
              </div>
              {/* As tags são exibidas se não estiver desabilitado, se o produto NÃO for do tipo "Texto" E se o radio button de criação de texto estiver ativo ('1') */}
              {!disabledCard && !productInvolvesText && createText === '1' && (
                <div className="bx--row flexible sm-margin">
                  <div className="tags bx--col-xs-12 v-md-margin">
                    <button className="button button--clear" onClick={() => this.addTag('<CHAMADA>', 0)} type="submit"><span className="bx--tag bx--tag--ibm">Chamada</span></button>
                    <button className="button button--clear" onClick={() => this.addTag('<PRAZO>', 0)} type="submit"><span className="bx--tag bx--tag--ibm">+ prazo pra pagar</span></button>
                    <button className="button button--clear" onClick={() => this.addTag('<DESCONTOS_OFERTAS>', 0)} type="submit"><span className="bx--tag bx--tag--ibm">Descontos e ofertas exclusivas</span></button>
                    <button className="button button--clear" onClick={() => this.addTag('<BAIXE_APP>', 0)} type="submit"><span className="bx--tag bx--tag--ibm">whatsapp + qrcode</span></button>
                    <button className="button button--clear" onClick={() => this.addTag('<PARCELAMENTO>', 0)} type="submit"><span className="bx--tag bx--tag--ibm">Parcelamento</span></button>
                    <button className="button button--clear" onClick={() => this.addTag('<AUMENTO_LIMITE>', 0)} type="submit"><span className="bx--tag bx--tag--ibm">Aumento de limite</span></button>
                    <button className="button button--clear" onClick={() => this.addTag('<CARTAO_ADICIONAL>', 0)} type="submit"><span className="bx--tag bx--tag--ibm">Cartão adicional</span></button>
                    <button className="button button--clear" onClick={() => this.addTag('<RAPIDA_APROVACAO>', 0)} type="submit"><span className="bx--tag bx--tag--ibm">Rápida aprovação</span></button>
                  </div>
                </div>
              )}
            </div>
          ) : (
            listBriefings.map((item, index) => (
              <div key={index}>
                <div className="bx--row">
                  <div className="bx--col-xs-12 bx--col-md-12">
                    <label className="bx--label">
                      Briefing de {productInvolvesText ? " Texto" : " Arte"}
                    </label>
                    {/* Descrição do briefing principal */}
                    {productInvolvesText ? (
                      <p className="description">
                        Criação de conteúdos do zero? Revisão de um conteúdo já feito?
                        Conceito criativo/slogan para campanha? Explique e forneça as informações que considera
                        relevantes para esse trabalho.
                      </p>
                    ) : (
                      <p className="description">
                        Descreva o que você precisa, com informações relevantes para a criação: objetivo, público,
                        canal onde o texto será divulgado, expectativa textual (tom de voz, estilo, palavras-chave e
                        se deve seguir alguma identidade textual, por exemplo)
                      </p>
                    )}
                    <Editor
                      editorState={editorState} // Editor Primário
                      editorClassName="border-editor"
                      onEditorStateChange={this.onPrimaryEditorStateChange}
                    />
                  </div>
                </div>
                {/* As tags são exibidas se não estiver desabilitado, se o produto NÃO for do tipo "Texto" E se o radio button de criação de texto estiver ativo ('1') */}
                {!disabledCard && !productInvolvesText && (
                  <div className="bx--row flexible sm-margin">
                    <div className="tags bx--col-xs-12 v-md-margin">
                      <button className="button button--clear" onClick={() => this.addTag('<CHAMADA>', index)} type="submit"><span className="bx--tag bx--tag--ibm">Chamada</span></button>
                      <button className="button button--clear" onClick={() => this.addTag('<PRAZO>', index)} type="submit"><span className="bx--tag bx--tag--ibm">+ prazo pra pagar</span></button>
                      <button className="button button--clear" onClick={() => this.addTag('<DESCONTOS_OFERTAS>', index)} type="submit"><span className="bx--tag bx--tag--ibm">Descontos e ofertas exclusivas</span></button>
                      <button className="button button--clear" onClick={() => this.addTag('<BAIXE_APP>', index)} type="submit"><span className="bx--tag bx--tag--ibm">whatsapp + qrcode</span></button>
                      <button className="button button--clear" onClick={() => this.addTag('<PARCELAMENTO>', index)} type="submit"><span className="bx--tag bx--tag--ibm">Parcelamento</span></button>
                      <button className="button button--clear" onClick={() => this.addTag('<AUMENTO_LIMITE>', index)} type="submit"><span className="bx--tag bx--tag--ibm">Aumento de limite</span></button>
                      <button className="button button--clear" onClick={() => this.addTag('<CARTAO_ADICIONAL>', index)} type="submit"><span className="bx--tag bx--tag--ibm">Cartão adicional</span></button>
                      <button className="button button--clear" onClick={() => this.addTag('<RAPIDA_APROVACAO>', index)} type="submit"><span className="bx--tag bx--tag--ibm">Rápida aprovação</span></button>
                    </div>
                  </div>
                )}
              </div>
            ))
          )}

          {/* Editor Secundário: Mostra apenas se o produto NÃO for do tipo "Texto" E se "Sim" for selecionado no radio button */}


          <div className="bx--row">
            <div className="bx--col-xs-12 bx--col-sm-6 v-md-margin">
              <Button
                onClick={() => {
                  this.advance(); // Chama advance para salvar
                }}
                disabled={!this.briefingOk()} // Desabilita se a validação não passar
              >
                Salvar Briefing
              </Button>
              <Button kind="ghost" className="h-sm-margin" onClick={this.cancel}>
                Cancelar
              </Button>
            </div>
          </div>
        </div>
      </StepCard>
    );
  }
}

export default BriefingRequestProduct;



// WEBPACK FOOTER //
// ./src/components/agency/requests/BriefingRequestProduct.js